import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './SourceFabric.css';
import logoPng from '../../assets/logoFab2.png';

const SourceFabric = () => {
    return (
        <div className="sourcefabric-container">
            <h3 className='sourcefabric-title' data-aos="fade-down"><img   src={`${logoPng}?time=${Date.now()}`}
                          alt="logo"
                          style={{
                            width: "100px",
                            marginTop: "0.5rem",
                          }} /></h3>
            <h2 className='sourcefabric-heading' data-aos="fade-down">Ready to source your fabrics <br />with FabInsta?</h2>
            <p className='sourcefabric-description' data-aos="fade-down">Let us help you bring your vision to life with perfect fabrics. Start Your Journey with Us Today!</p>
            <button className="sourcefabric-btn" data-aos="fade-down">Get Started<FontAwesomeIcon className='btn_icon' icon={faCircleArrowRight} /></button>
        </div>
    )
}

export default SourceFabric
